import React, { lazy } from "react";

const Landing = lazy(() => import("./pages/landing/Landing"));
const Privacy = lazy(() => import("./pages/Privacy"));

const routes = {
    "/": () => <Landing />,
    "/privacy": () => <Privacy />,
};

export default routes;
